import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LAUNCH_APP_URL } from "@/config";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative px-6 py-24 lg:px-10 lg:py-32"
    >
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="grain relative overflow-hidden rounded-3xl bg-[#0a0a0a] px-8 py-20 text-center sm:px-16"
        >
          <div
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "radial-gradient(60% 80% at 50% 0%, rgba(13,148,136,0.28) 0%, rgba(10,10,10,0) 60%)",
            }}
          />
          <div className="relative">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-teal">
              Get started
            </span>
            <h2 className="mx-auto mt-5 max-w-2xl font-heading text-4xl font-bold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
              Run your business
              <br />
              with intelligence.
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg">
              Step into AMRA AI Business OS — the system built from real
              operational challenges, ready to work for yours.
            </p>
            <div className="mt-10 flex justify-center">
              <a
                data-testid="final-launch-app"
                href={LAUNCH_APP_URL}
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-4 text-sm font-medium text-[#0a0a0a] transition-transform duration-200 hover:scale-[1.03]"
              >
                Launch App
                <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
